import imageCompression from "browser-image-compression";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Button, Col, Image, InputGroup, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Cropper from "react-easy-crop";
import { MdClose, MdOutlineAdd } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import swal from "sweetalert";
import confirmationImage from "../../assets/check-image.svg";
import closeIcon from "../../assets/close_Icon.svg";
import editwhite from "../../assets/edit-white.svg";
import iicon from "../../assets/i.svg";
import uploadArrow from "../../assets/others/upload.svg";
import Preview from "../../assets/preview.svg";
import theme1 from "../../assets/theme1.png";
import theme2 from "../../assets/theme2.png";
import theme3 from "../../assets/theme3.png";
import Previewhite from "../../assets/view-white.svg";
import { RegEx } from "../../Utils/RegEx";
import { customRequest } from "../API/custom-request";
import { HomeSubmitAPi } from "../API/MarketPlaceSetUp/HomeSubmit";
import Loader from "../Loader/Loader";
import NoDataText from "../NoDataText";
import { GetHomePage } from "./../API/MarketPlaceSetUp/GetHomePage";
import { HomeAPi } from "./../API/MarketPlaceSetUp/HomeAPi";
import getCroppedImg from "./cropImage";

export const HomePageSetup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [requestResponse, setRequestResponse] = useState(true);

  // theme
  const [showP1, setshowP1] = useState(false);
  const [showP2, setshowP2] = useState(false);
  const [showP3, setshowP3] = useState(false);
  const [showP4, setshowP4] = useState(false);

  const [theme_id, settheme_id] = useState("");
  const [ThemeSelected, setThemeSelected] = useState("");
  //image upload
  const [image, setImage] = useState(null);
  const [imageType, setimageType] = useState(null);
  // multiple images
  const [base64, setBase64] = useState("");
  const [ApiBannerArray, setApiBannerArray] = useState([]);
  const [imageURL, setImageURL] = useState("");

  const [errorLabelName, setErrorLabelName] = useState("");
  // feild
  const [PageName, setPageName] = useState("Home");
  const [PageUrl, setPageUrl] = useState("");
  // page-vist-link
  const [IsVisitPage, setIsVisitPage] = useState(false);
  const [VistPageLink, setVistPageLink] = useState("");

  const [PageTitle, setPageTitle] = useState("");
  const [MetaDescription, setMetaDescription] = useState("");
  const [AddNavigation, setAddNavigation] = useState([]);
  const [isCheck, setIsCheck] = useState([]);
  const [idValue, setidValue] = useState([]);
  const [AddShortcuts, setAddShortcuts] = useState("");
  // social
  const [Facebook, setFacebook] = useState("");
  const [Twitter, setTwitter] = useState("");
  const [Instagram, setInstagram] = useState("");
  const [LinkedIn, setLinkedIn] = useState("");
  const [Email, setEmail] = useState("");
  const [Phone, setPhone] = useState("");
  // feild--Err
  const [PageNameErr, setPageNameErr] = useState("");
  const [PageUrlErr, setPageUrlErr] = useState("");
  const [imageErr, setImageErr] = useState("");
  const [BannerImgErr, setBannerImgErr] = useState("");
  const [PageTitleErr, setPageTitleErr] = useState("");
  const [MetaDescriptionErr, setMetaDescriptionErr] = useState("");
  const [AddNavigationErr, setAddNavigationErr] = useState("");
  const [AddShortcutsErr, setAddShortcutsErr] = useState("");
  // social - err
  const [FacebookErr, setFacebookErr] = useState("");
  const [TwitterErr, setTwitterErr] = useState("");
  const [InstagramErr, setInstagramErr] = useState("");
  const [LinkedInErr, setLinkedInErr] = useState("");
  const [EmailErr, setEmailErr] = useState("");
  const [PhoneErr, setPhoneErr] = useState("");
  // addnav-show.hide
  const [HideAddNav, setHideAddNav] = useState(false);
  const [AddNavCheckBox, setAddNavCheckBox] = useState(false);
  const [AddNavItems, setAddNavItems] = useState(false);
  const [isDisable, setisDisable] = useState(null);
  // addNav
  const [AddNavData, setAddNavData] = useState([]);
  // addShortcut
  const [isCheckShortcut, setIsCheckShortcut] = useState([]);
  const [idValueShortcut, setidValueShortcut] = useState([]);
  const [AddShortcutData, setAddShortcutData] = useState([]);
  // addShortcut-show.hide
  const [HideAddShortcut, setHideAddShortcut] = useState(false);
  const [AddShortcutCheckBox, setAddShortcutCheckBox] = useState(false);
  const [AddShortcutItems, setAddShortcutItems] = useState(false);
  const [isDisableShortcut, setisDisableShortcut] = useState(null);

  // popups
  const [show, setShow] = useState(false);
  const [showCustomDomain, setShowCustomDomain] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [ShowBrowseLogo, setShowBrowseLogo] = useState(false);
  // img
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImageBanner, setCroppedImageBanner] = useState(null);
  const [bannerName, setBannerName] = useState("");
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  //toggle button
  const [listOption, setListOption] = useState("businesses");
  // Add offers_status state
  const [offers_status, setOffersStatus] = useState(true);

  // banner
  const inputRef = useRef();

  const triggerFileSelectPopup = () => inputRef.current.click();

  const [ImagePathLogo, setImagePathLogo] = useState("");

  // banner-array
  const [profileimageBanner, setprofileImageBanner] = useState("");
  const [showBanner, setShowBanner] = useState(false);
  const [profileimageBannerSelected, setprofileImageBannerSelected] =
    useState("");
  const [NullBannerImgErr, setNullBannerImgErr] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // logo
  const [cropImg, setcropImg] = useState("");
  const [prevImg, setPrevimg] = useState("");
  const [iscropImgEdited, setIscropImgEdited] = useState(false);
  const [MmsCityId, setMmsCityId] = useState(0);

  const requestHandler = async () => {
    setShowCustomDomain(true);
  };

  const requestHandlerApi = async () => {
    setButtonDisabled(true);
    setTimeout(() => {
      setButtonDisabled(false);
    }, 1000);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
    };
    try {
      const requestResponse = await customRequest(data);
      if (requestResponse.status === 200) {
        swal({
          title: requestResponse.message,
          icon: "success",
          button: "Ok",
        });
        setLoading(false);
        setShowCustomDomain(false);
        setRequestResponse(false);
      } else {
        toast.dismiss();
        toast.clearWaitingQueue();
        toast.error(requestResponse.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
        setShowCustomDomain(false);
        setRequestResponse(true);
      }
    } catch (error) {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(error, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
      setShowCustomDomain(false);
      setRequestResponse(true);
    } finally {
      setLoading(false);
      setShowCustomDomain(false);
    }
  };

  const handleSetCropperImg = async (e) => {
    const imageFile = e.target.files[0];
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    try {
      const compressedFile = await imageCompression(imageFile, options);
      const compressedSize = compressedFile.size / 1024 / 1024;
      const baseval = await imageCompression.getDataUrlFromFile(compressedFile);
      if (compressedSize > options.maxSizeMB) {
        setPrevimg("");
        swal({
          title: "Error!",
          text: "Please select a valid image",
          icon: "error",
          button: "Ok",
        });
      } else {
        setShow(true);
        setPrevimg(URL.createObjectURL(compressedFile));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const modelClose = () => {
    setShow(false);
  };

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        prevImg,
        croppedAreaPixels,
        rotation
      );
      setcropImg(croppedImage);
      setImageErr("");
      setIscropImgEdited(true);
      setShow(false);
      setZoom(1);
      setRotation(0);
      const imgType = croppedImage.split(";");
      const imgTypeData = imgType[0].split("/");
      setimageType(imgTypeData[1]);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  const showError = () => {
    setErrorLabelName("Please enter a valid URL.");
  };
  // end - copy - logo-img
  useEffect(() => {
    handleNavShortcuts();
  }, []);

  const handleNavShortcuts = async () => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
    };
    const response = await HomeAPi(data, () => {
      navigate("/");
    });
    if (response == false) {
      swal({
        title: NoDataText.InternalErr,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
    } else {
      if (response.success == true) {
        setAddNavData(response.navigations);
        setAddShortcutData(response.shortcuts);
        GetDataAPI(response.navigations, response.shortcuts);
      } else if (response.staus === 429) {
        setLoading(false);
        swal({
          text: `${response.message}`,
          icon: "warning",
          buttons: "OK",
          dangerMode: false,
        });
      } else {
        setLoading(false);
        swal({
          text: `${response.message}`,
          icon: "warning",
          buttons: "OK",
          dangerMode: false,
        });
      }
    }
  };
  // getIfData
  const GetDataAPI = async (navigation, shortcuts) => {
    const cityId = localStorage.getItem("cityId");
    const payload = {
      mms_city_id: parseInt(cityId),
    };
    const response = await GetHomePage(payload, () => {
      navigate("/");
    });
    if (response.status === 429) {
      setLoading(true);
      swal({
        title: `${response.message}`,
        icon: "error",
        buttons: "OK",
      });
    } else if (response == false) {
      swal({
        title: NoDataText.InternalErr,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
    } else {
      if (response.success == true) {
        setLoading(false);

        // Set offers_status from API response
        setOffersStatus(response.data.offers_status);

        // If offers_status is false, force set listOption to "businesses"
        if (!response.data.offers_status) {
          setListOption("businesses");
        } else {
          // Only use the list_option from API if offers_status is true
          setListOption(response.data.list_option || "businesses");
        }
        setPageUrl(response.data.page_url);
        setRequestResponse(response.data.custom_req_response);
        setIsVisitPage(response.data.view_page_url);
        setVistPageLink(response.data.page_view_url);
        setPageTitle(response.data.page_title);
        setMetaDescription(response.data.description);
        setEmail(response.data.email_address);
        setPhone(response.data.phone_number);
        setFacebook(response.data.facebook_url);
        setTwitter(response.data.twitter_url);
        setInstagram(response.data.instagram_url);
        setLinkedIn(response.data.linkedIn_url);
        setMmsCityId(response.data.mms_city_id);

        if (response.data.logo_image.length == 0) {
          setcropImg("");
        } else {
          setcropImg(response.data.logo_image);
          const Cropped = response.data.logo_image.split("/");
          setImagePathLogo(Cropped[3] + "/" + Cropped[4] + "/" + Cropped[5]);
        }

        if (response.data.banner_image.length == 0) {
        } else {
          setApiBannerArray(response.data.banner_image);
        }

        if (response.data.theme_id != "") {
          setThemeSelected(`p${response.data.theme_id}`);
          settheme_id(response.data.theme_id);
        } else {
          setThemeSelected("");
          settheme_id("");
        }
        setAddNavItems(true);
        setHideAddNav(true);
        const arrNav = response.data.navigation;
        const fil1 = arrNav.map((item, key) =>
          navigation.filter((i) => i.navigation_id == item)
        );
        const result = [].concat(...fil1);
        setIsCheck(result.map((i) => i.navigation_name));
        setidValue(response.data.navigation);
        // shortcut
        setHideAddShortcut(true);
        setAddShortcutItems(true);
        const arrNavShotcut = response.data.shortcut;
        const fil2 = arrNavShotcut.map((item, key) =>
          shortcuts.filter((i) => i.shortcut_id == item)
        );
        const result1 = [].concat(...fil2);
        setIsCheckShortcut(result1.map((i) => i.shortcut_name));
        setidValueShortcut(response.data.shortcut);
      } else {
        setLoading(false);
        swal({
          text: `${response.message}`,
          icon: "warning",
          buttons: "OK",
          dangerMode: false,
        });
      }
    }
  };

  // themeActive
  const hanldeThemeSelected = (id) => {
    setThemeSelected(`p${id}`);
    settheme_id(id);
  };
  // feild data entered by user
  const onChangeHandler = async (fieldName, value) => {
    if (fieldName === "PageTitle") {
      setPageTitle(value);
      if (value.length == 0) {
        setPageTitleErr("* Please enter page title");
      } else {
        setPageTitleErr("");
      }
    } else if (fieldName === "MetaDescription") {
      setMetaDescription(value);
      if (value.length == 0) {
        setMetaDescriptionErr("* Please enter meta description");
      } else {
        setMetaDescriptionErr("");
      }
    }

    // social

    // fb-- /(?:https?:\/\/)?(?:www\.)?(mbasic.facebook|m\.facebook|facebook|fb)\.(com|me)\/(?:(?:\w\.)*#!\/)?(?:pages\/)?(?:[\w\-\.]*\/)*([\w\-\.]*)/
    else if (fieldName === "Facebook") {
      setFacebook(value);
      let re = RegEx.facebook__regEx;
      if (!re.test(value)) {
        setFacebookErr("* Please enter valid facebook address");
      } else {
        setFacebookErr("");
      }
    }
    // tw -- /(https:\/\/twitter.com\/(?![a-zA-Z0-9_]+\/)([a-zA-Z0-9_]+))/
    else if (fieldName === "Twitter") {
      let re = RegEx.twitter__regEx;
      setTwitter(value);
      if (!re.test(value)) {
        setTwitterErr("* Please enter valid twitter address");
      } else {
        setTwitterErr("");
      }
    }
    // insta -- /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}$/
    else if (fieldName === "Instagram") {
      setInstagram(value);
      let re = RegEx.instagram__regEx;
      if (!re.test(value)) {
        setInstagramErr("* Please enter valid instagram address");
      } else {
        setInstagramErr("");
      }
    }
    // linkedin -- /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)/
    else if (fieldName === "LinkedIn") {
      setLinkedIn(value);
      let re = RegEx.linkedIn__regEx;
      if (!re.test(value)) {
        setLinkedInErr("* Please enter valid linkedIn address");
      } else {
        setLinkedInErr("");
      }
    }
    // email -  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
    else if (fieldName === "Email") {
      setEmail(value);
      let re = RegEx.email__regEx;
      if (!re.test(value)) {
        setEmailErr("* Please enter valid email address");
      } else {
        setEmailErr("");
      }
    }
    // phone
    else if (fieldName === "Phone") {
      setPhone(value);
      let re = RegEx.phone__regEx;
      if (!re.test(value)) {
        setPhoneErr("* Please enter valid phone number");
      } else {
        setPhoneErr("");
      }
    }
  };
  // onSave
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (cropImg == "") {
      setImageErr("*Please add logo!");
    }
    if (ApiBannerArray.length == 0) {
      setBannerImgErr("*Please add banner images!");
    }
    if (PageTitle == null || undefined) {
      setPageTitleErr("*Please enter page title!");
    }
    if (MetaDescription == null || undefined) {
      setMetaDescriptionErr("*Please enter meta description!");
    }

    if (Email?.length == 0) {
      setEmailErr("* Please enter email address!");
    }
    if (Phone == null || undefined) {
      setPhoneErr("*Please enter phone number!");
    }
    if (
      PageName.length != 0 &&
      PageTitle.length != 0 &&
      MetaDescription.length != 0 &&
      Email.length != 0 &&
      Phone.length != 0 &&
      imageErr.length == 0 &&
      BannerImgErr.length == 0 &&
      PageTitleErr.length == 0 &&
      MetaDescriptionErr.length == 0 &&
      EmailErr.length == 0 &&
      PhoneErr.length == 0
    ) {
      setLoading(true);
      const cityId = localStorage.getItem("cityId");
      const data = {
        mms_city_id: parseInt(cityId),
        theme_id: theme_id == "" ? 1 : theme_id,
        page_name: PageName,
        page_url: PageUrl,
        page_title: PageTitle,
        meta_description: MetaDescription,
        navigations: idValue,
        shortcuts: idValueShortcut,
        facebook_url: Facebook,
        twitter_url: Twitter,
        instagram_url: Instagram,
        linkedIn_url: LinkedIn,
        email_address: Email,
        phone_number: Phone,
        list_option: listOption,
        logo_image:
          iscropImgEdited == false
            ? ImagePathLogo
            : { data: cropImg, file_type: "png" },
        logo_image_change: iscropImgEdited == false ? 0 : 1,
        banner_images: ApiBannerArray,
      };

      const coupondetailData = await HomeSubmitAPi(data, () => {
        navigate("/");
      });
      if (coupondetailData == false) {
        swal({
          title: NoDataText.InternalErr,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        });
      } else {
        if (coupondetailData.success == true) {
          setLoading(false);
          swal({
            title: `${coupondetailData.message}`,
            icon: "success",
            buttons: "Ok",
          }).then((success) => {
            console.log(success);
          });
        } else if (coupondetailData.status == 429) {
          swal({
            title: `${coupondetailData.message}`,
            icon: "success",
            buttons: "Ok",
          });
          setLoading(true);
        } else {
          setLoading(false);
          swal({
            title: `${coupondetailData.message}`,
            icon: "error",
            buttons: "Ok",
          });
          swal.stopLoading();
          swal.close();
        }
      }
    }
  };

  // onDiscard
  const handleDiscard = () => {
    window.location.reload(false);
  };
  // banner-add
  const handleDeleteImage = (e, key) => {
    const filterImage = ApiBannerArray.filter((elem, k) => k != key);
    setApiBannerArray(filterImage);
  };

  const addBannerFun = () => {
    var obj = {
      data: "",
      file_type: "",
      file_url: "",
      file_name: "",
    };
    setApiBannerArray([...ApiBannerArray, obj]);
  };

  useEffect(() => {
    ApiBannerArray.forEach((item, index) => {
      if (!item.data) {
        setNullBannerImgErr(true);
      } else {
        setNullBannerImgErr(false);
      }
    });
  }, [ApiBannerArray]);

  const handleBannerImage = async (e, i) => {
    setErrorLabelName("");
    const fsize = e.target.files[0].size;
    setBannerName(e.target.files[0].name);

    const maxSizeInBytes = 5 * 1024 * 1024;
    if (fsize < maxSizeInBytes) {
      const imageFile = e.target.files[0];

      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      try {
        const compressedFile = await imageCompression(imageFile, options);
        const compressedSize = compressedFile.size / 1024 / 1024;
        const baseval = await imageCompression.getDataUrlFromFile(
          compressedFile
        );

        if (!e.target.files[0].name.match(/\.(jpg|jpeg|png|gif|jfif)$/)) {
          setShow(false);
          setPrevimg("");
          swal({
            title: "Error!",
            text: "Please select a valid image",
            icon: "error",
            button: "Ok",
          });
        } else if (compressedSize > options.maxSizeMB) {
          swal({
            title: "Error!",
            text: `File too Big, please select a file less than ${
              options.maxSizeMB / (1024 * 1024)
            }MB`,
            icon: "error",
            button: "Ok",
          });
        } else {
          setShowBanner(true);
          setprofileImageBanner(URL.createObjectURL(compressedFile));
          setprofileImageBannerSelected(ApiBannerArray[i]);
          var reader = new FileReader();
          reader.readAsDataURL(e.target.files[0]);
          reader.onload = () => {
            setBase64(reader.result);
          };
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      swal({
        title: "Error!",
        text: "Please select an image less than 5mb",
        icon: "error",
        button: "Ok",
      });
    }
  };
  // banner-add-images-save button in cropper
  const showCroppedImageBanner = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        profileimageBanner,
        croppedAreaPixels,
        rotation
      );
      const imgType = croppedImage.split(";");
      const imgTypeData = imgType[0].split("/");

      setCroppedImageBanner(croppedImage);
      profileimageBannerSelected.data = croppedImage;
      profileimageBannerSelected.file_type = imgTypeData[1];
      profileimageBannerSelected.file_name = bannerName;
      setprofileImageBanner(croppedImage);
      setShowBanner(false);
      setZoom(1);
      setRotation(0);
      setNullBannerImgErr(false);
      setBannerImgErr("");
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  // add nav
  const handleAddNav = () => {
    setHideAddNav(true);
    setAddNavCheckBox(true);
  };
  // add shortcut
  const handleAddShortcut = () => {
    setHideAddShortcut(true);
    setAddShortcutCheckBox(true);
  };

  // checkbox - Add Nav
  const handleClick = (e, key) => {
    const { checked } = e.target;
    setIsCheck([...isCheck, AddNavData[key].navigation_name]);
    setidValue([...idValue, AddNavData[key].navigation_id]);
    if (!checked) {
      setIsCheck(
        isCheck.filter((item) => item != AddNavData[key].navigation_name)
      );
      setidValue(
        idValue.filter((item) => item != AddNavData[key].navigation_id)
      );
    }
  };

  useEffect(() => {
    if (isCheck.length > 4) {
      setisDisable(false);
      swal({
        title: "You can select maximum 4 navigation",
        icon: "info",
        buttons: "Ok",
        dangerMode: true,
      }).then(() => {
        handleCancelCheckBox();
      });
    }
  }, [isCheck, idValue]);

  const handleCancelCheckBox = () => {
    let elemsToDelete = 1;
    isCheck.splice(isCheck.length - elemsToDelete, elemsToDelete);
    idValue.splice(idValue.length - elemsToDelete, elemsToDelete);
    setisDisable(false);
    setAddNavItems(true);
    setAddNavCheckBox(false);
  };

  const handleApplyCheckBox = () => {
    setHideAddNav(true);
    setAddNavCheckBox(false);
    setAddNavItems(true);
  };
  const handleEdit = () => {
    setisDisable(false);
    setHideAddNav(true);
    setAddNavCheckBox(true);
    setAddNavItems(false);
    setIsCheck([...isCheck]);
  };
  // drag item - reorder of navigations
  const handleDropDataField = (droppedItem) => {
    if (!droppedItem.destination) return;
    var updatedList = [...isCheck];
    var updatedListId = [...idValue];
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    const [reorderedItemId] = updatedListId.splice(droppedItem.source.index, 1);
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    updatedListId.splice(droppedItem.destination.index, 0, reorderedItemId);
    setIsCheck(updatedList);
    setidValue(updatedListId);
    if (droppedItem.destination.index === 0 || droppedItem.destination.index) {
    }
  };
  //  delete - navigation item
  const handleDelete = (e, key) => {
    setIsCheck(isCheck.filter((item) => item !== isCheck[key]));
    setidValue(idValue.filter((item) => item !== idValue[key]));
  };

  // ADD shortcuts
  // checkbox - Add Nav
  const handleClickShortcut = (e, key) => {
    const { checked } = e.target;
    setIsCheckShortcut([
      ...isCheckShortcut,
      AddShortcutData[key].shortcut_name,
    ]);
    setidValueShortcut([...idValueShortcut, AddShortcutData[key].shortcut_id]);
    if (!checked) {
      setIsCheckShortcut(
        isCheckShortcut.filter(
          (item) => item !== AddShortcutData[key].shortcut_name
        )
      );
      setidValueShortcut(
        idValueShortcut.filter(
          (item) => item !== AddShortcutData[key].shortcut_id
        )
      );
    }
  };
  useEffect(() => {
    if (isCheckShortcut.length > 2) {
      setisDisableShortcut(true);
    }
  }, [isCheckShortcut]);

  const handleCancelCheckBoxShortcut = () => {
    setisDisableShortcut(false);
  };

  const handleApplyCheckBoxShortcut = () => {
    setHideAddShortcut(true);
    setAddShortcutCheckBox(false);
    setAddShortcutItems(true);
  };

  const handleEditShortcut = () => {
    setisDisableShortcut(false);
    setHideAddShortcut(true);
    setAddShortcutCheckBox(true);
    setAddShortcutItems(false);
    setIsCheckShortcut([...isCheckShortcut]);
  };

  // drag item - reorder of navigations
  const handleDropDataFieldShortcut = (droppedItem) => {
    if (!droppedItem.destination) return;
    var updatedList = [...isCheckShortcut];
    var updatedListId = [...idValueShortcut];
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    const [reorderedItemId] = updatedListId.splice(droppedItem.source.index, 1);
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    updatedListId.splice(droppedItem.destination.index, 0, reorderedItemId);
    setIsCheckShortcut(updatedList);
    setidValueShortcut(updatedListId);
    if (droppedItem.destination.index === 0 || droppedItem.destination.index) {
    }
  };

  //  delete - navigation item
  const handleDeleteShortcut = (e, key) => {
    setIsCheckShortcut(
      isCheckShortcut.filter((item) => item !== isCheckShortcut[key])
    );
    setidValueShortcut(
      idValueShortcut.filter((item) => item !== idValueShortcut[key])
    );
  };

  const handleImageUrl = (e, key) => {
    ApiBannerArray[key].file_url = e.target.value;
    setImageURL(ApiBannerArray[key].file_url);
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <Row>
        <Col md="1"></Col>
        <Col md="10">
          <div className="formmain mx-0 mt-2 signin-row profile-form pb-4 page-setup">
            <div>
              <div className="theme-custom-domain">
                <Form.Group controlId="formListOption">
                  <p className="orange-text">Select Listing Option</p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "8px",
                    }}
                  ></div>
                  <div className="toggle-container">
                    <div className="toggle-options">
                      <label
                        className={`toggle-option ${
                          listOption === "businesses" ? "active" : ""
                        }`}
                      >
                        <input
                          type="radio"
                          name="listOption"
                          value="businesses"
                          checked={listOption === "businesses"}
                          onChange={(e) => setListOption(e.target.value)}
                        />
                        <span>Businesses</span>
                      </label>
                      <label
                        className={`toggle-option ${
                          listOption === "offers" ? "active" : ""
                        } ${!offers_status ? "disabled-toggle-option" : ""}`}
                      >
                        <input
                          type="radio"
                          name="listOption"
                          value="offers"
                          checked={listOption === "offers"}
                          onChange={(e) => {
                            if (offers_status) {
                              setListOption(e.target.value);
                            }
                          }}
                          disabled={!offers_status}
                        />
                        <span>Offers</span>
                      </label>
                    </div>
                  </div>
                </Form.Group>
                {IsVisitPage === true ? (
                  <p className="text-right orange-text mx-2 mb-2">
                    <a
                      href={`${VistPageLink}`}
                      target="_blank"
                      className="orange-text"
                    >
                      <Image src={Preview} className="mb-1"></Image>{" "}
                      <b>Visit Page</b>
                    </a>
                  </p>
                ) : (
                  <></>
                )}

                <button
                  className={
                    requestResponse
                      ? "green-button min-w-270"
                      : "green-button min-w-270 disabled-button"
                  }
                  onClick={requestHandler}
                  disabled={!requestResponse}
                >
                  <MdOutlineAdd size={25} />
                  Request Custom Domain
                </button>
              </div>
            </div>
            <p className="page-maintitle pt-1 mb-3 pb-3">Select Theme</p>
            <Row className="mb-5 HomePageTheme">
              <Col
                md="3"
                onMouseEnter={() => {
                  setshowP1(true);
                }}
                onMouseLeave={() => setshowP1(false)}
                onClick={() => hanldeThemeSelected(1)}
              >
                <div
                  className={`theme-main ${
                    ThemeSelected == "p1" && "theme-main-active"
                  }`}
                >
                  <Image
                    src={theme2}
                    width="200px"
                    className="mb-3 theme-img"
                  ></Image>
                  <div style={{ height: 45 }}>
                    <p className="text-center">
                      <b>Theme 1</b>
                    </p>
                    {showP1 ? (
                      <p className="text-center mb-2">
                        <a
                          className="orange-text orange-prev-btn"
                          href={
                            process.env.REACT_APP_COMMON_URL +
                            "theme_pdf/ThemeOne.pdf"
                          }
                          target="_blank"
                        >
                          <Image src={Previewhite} className="mb-1"></Image>{" "}
                          Preview
                        </a>
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </Col>
              <Col
                md="3"
                onMouseEnter={() => {
                  setshowP2(true);
                }}
                onMouseLeave={() => setshowP2(false)}
                onClick={() => hanldeThemeSelected(2)}
              >
                <div
                  className={`theme-main ${
                    ThemeSelected == "p2" && "theme-main-active"
                  }`}
                >
                  <Image
                    src={theme1}
                    width="200px"
                    className="mb-3 theme-img"
                  ></Image>
                  <div style={{ height: 45 }}>
                    <p className="text-center">
                      <b>Theme 2</b>
                    </p>
                    {showP2 ? (
                      <p className="text-center mb-2">
                        <a
                          className="orange-text orange-prev-btn"
                          href={
                            process.env.REACT_APP_COMMON_URL +
                            "theme_pdf/ThemeTwo.pdf"
                          }
                          target="_blank"
                        >
                          <Image src={Previewhite} className="mb-1"></Image>{" "}
                          Preview
                        </a>
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </Col>
              <Col
                md="3"
                onMouseEnter={() => {
                  setshowP3(true);
                }}
                onMouseLeave={() => setshowP3(false)}
                onClick={() => hanldeThemeSelected(3)}
              >
                <div
                  className={`theme-main ${
                    ThemeSelected == "p3" && "theme-main-active"
                  }`}
                >
                  <Image
                    src={theme3}
                    width="200px"
                    className="mb-3 theme-img"
                  ></Image>
                  <div style={{ height: 45 }}>
                    <p className="text-center">
                      <b>Theme 3</b>
                    </p>
                    {showP3 ? (
                      <p className="text-center pb-2 ">
                        <a
                          className="orange-text orange-prev-btn"
                          href={
                            process.env.REACT_APP_COMMON_URL +
                            "theme_pdf/ThemeThree.pdf"
                          }
                          target="_blank"
                        >
                          <Image src={Previewhite} className="mb-1"></Image>{" "}
                          Preview
                        </a>
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </Col>
              {MmsCityId === 28 && (
                <Col
                  md="3"
                  onMouseEnter={() => {
                    setshowP4(true);
                  }}
                  onMouseLeave={() => setshowP4(false)}
                  onClick={() => hanldeThemeSelected(4)}
                >
                  <div
                    className={`theme-main ${
                      ThemeSelected == "p4" && "theme-main-active"
                    }`}
                  >
                    <Image
                      src={theme2}
                      width="200px"
                      className="mb-3 theme-img"
                    ></Image>
                    <div style={{ height: 45 }}>
                      <p className="text-center">
                        <b>Theme 4</b>
                      </p>
                      {showP4 ? (
                        <p className="text-center mb-2">
                          <a
                            className="orange-text orange-prev-btn"
                            href={
                              process.env.REACT_APP_COMMON_URL +
                              "theme_pdf/ThemeOne.pdf"
                            }
                            target="_blank"
                          >
                            <Image src={Previewhite} className="mb-1"></Image>{" "}
                            Preview
                          </a>
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </Col>
              )}
            </Row>
            <Row>
              <div className="logo-banner-div">
                <Col className="mb-0 banner-upload logo-bannerOne">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <div style={{ display: "flex", gap: "20px" }}>
                      <Form.Label className="form-label-custom">
                        Add Logo <span className="star-required">* </span>
                        {["top"].map((placement) => (
                          <OverlayTrigger
                            key={placement}
                            placement={placement}
                            overlay={
                              <Tooltip
                                id={`tooltip-${placement}`}
                                className="Tooltips"
                                style={{ opacity: "1" }}
                              >
                                This is the logo that will come on the header
                                inside the home page.{" "}
                                <b>
                                  (Please upload logo image in dimension of 1:1
                                  ratio)
                                </b>
                              </Tooltip>
                            }
                          >
                            <Image
                              src={iicon}
                              className="mb-1"
                              width="15px"
                            ></Image>
                          </OverlayTrigger>
                        ))}
                      </Form.Label>
                    </div>
                    <div className="imgsrc" onClick={triggerFileSelectPopup}>
                      <input
                        type="file"
                        accept="image/*"
                        ref={inputRef}
                        style={{ display: "none" }}
                        onChange={handleSetCropperImg}
                        onClick={(e) => (e.target.value = null)}
                      />
                      <div className="croppedImage">
                        {cropImg == "" ? (
                          <div className="imgsrcMain">
                            <div
                              style={{ textAlign: "center" }}
                              className="centerText"
                            >
                              <img
                                src={uploadArrow}
                                style={{ marginTop: 20 }}
                              />
                              <p className="info_bannerImg">
                                Click here to upload logo
                              </p>
                              <label htmlFor="logoImg" className="browse_btn">
                                Browse
                              </label>
                              <img
                                className="img-circle-edit"
                                style={{
                                  backgroundColor: "rgb(243, 242, 242)",
                                  cursor: "pointer",
                                  width: "100%",
                                  height: "100%",
                                  display: "none",
                                }}
                              />
                              <input
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                onClick={(e) => (e.target.value = null)}
                              />{" "}
                            </div>
                          </div>
                        ) : (
                          <img src={cropImg} className="logo_img_home" />
                        )}
                      </div>
                    </div>
                    <Modal
                      show={show}
                      onHide={() => setShow(false)}
                      style={{ marginTop: 0 }}
                    >
                      <Modal.Header></Modal.Header>
                      <Modal.Body style={{ width: "100%", height: 350 }}>
                        <div>
                          <Cropper
                            image={prevImg}
                            crop={crop}
                            rotation={rotation}
                            zoom={zoom}
                            aspect={1 / 1}
                            showGrid={true}
                            onCropChange={setCrop}
                            onRotationChange={setRotation}
                            onCropComplete={onCropComplete}
                            onZoomChange={setZoom}
                          />
                        </div>
                      </Modal.Body>
                      <Modal.Footer className="modelFooter">
                        <button
                          className="close_btn_cropper"
                          onClick={modelClose}
                        >
                          Cancel
                        </button>
                        <button
                          className="green-btn mt-0 btn btn-primary"
                          onClick={showCroppedImage}
                        >
                          Save
                        </button>
                      </Modal.Footer>
                    </Modal>
                    {imageErr && <p className="text-danger">{imageErr}</p>}
                  </Form.Group>
                  <div className="saveButton">
                    <Button
                      variant="primary"
                      type="submit"
                      className="green-btn mt-3"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Save
                    </Button>
                  </div>
                </Col>
                <Col md="12" className="banner-upload logo-bannerTwo">
                  <Form.Group
                    className="mb-0 bannerGroup"
                    controlId="formBasicEmail"
                  >
                    <div className="flex-block">
                      <div>
                        <Form.Label className="form-label-custom">
                          {["top"].map((placement) => (
                            <OverlayTrigger
                              key={placement}
                              placement={placement}
                              overlay={
                                <Tooltip
                                  id={`tooltip-${placement}`}
                                  className="Tooltips"
                                  style={{ opacity: "1" }}
                                >
                                  Select up to 5 images to add to the homepage
                                  banner.
                                </Tooltip>
                              }
                            >
                              <Image
                                src={iicon}
                                className="mb-1"
                                width="15px"
                              ></Image>
                            </OverlayTrigger>
                          ))}
                          Add Banner Image{" "}
                          <span
                            style={{ fontSize: "11px!important" }}
                            className="orange-text"
                          >
                            <i>
                              {" "}
                              (Please upload banner images in dimension of 1500
                              x 450px)<span className="star-required">*</span>
                            </i>
                          </span>
                        </Form.Label>
                        <p className="info-text">
                          &#40;Please click on the save button below after
                          uploading banner images.&#41;
                        </p>
                      </div>
                      <div
                        className="add-more-wrapper"
                        style={{
                          display:
                            ApiBannerArray.length >= 1 &&
                            ApiBannerArray.length < 5
                              ? "flex"
                              : "none",
                        }}
                      >
                        <button
                          className="add-more-block"
                          disabled={NullBannerImgErr ? "disabled" : ""}
                          onClick={addBannerFun}
                          style={{
                            background: "#e66100",
                            color: "#fff",
                            border: "none",
                            borderRadius: 10,
                            padding: "7px 20px",
                            cursor: NullBannerImgErr
                              ? "not-allowed"
                              : "pointer",
                            opacity: NullBannerImgErr ? 0.5 : 1,
                          }}
                        >
                          Add more
                        </button>
                      </div>
                    </div>
                    {ApiBannerArray.length != 0 ? (
                      <>
                        {" "}
                        {ApiBannerArray.map((elem, i) => {
                          return (
                            <div className="url-image-wrapper">
                              <Col md="12" className="image-container">
                                <div className="browse_bannerImg">
                                  {elem.data ? (
                                    <div className="imgCropsection">
                                      <div className="bannerImg_Box">
                                        <div className="banner-image">
                                          <img
                                            src={elem.data}
                                            className="banner_imgs"
                                            alt="Banner image"
                                            id="left"
                                          />
                                        </div>
                                        <Form.Group
                                          className="mb-4 banner_url_text "
                                          controlId="formBasicEmail"
                                          style={{ width: "50%" }}
                                        >
                                          <div
                                            style={{
                                              display: "block",
                                              width: "100%",
                                            }}
                                          >
                                            {" "}
                                            <Form.Label className="form-label-custom">
                                              Banner Image URL
                                            </Form.Label>
                                            <InputGroup className="edit-border">
                                              <Form.Control
                                                type="text"
                                                placeholder="Enter Image URL"
                                                value={elem.file_url}
                                                onChange={(e) =>
                                                  handleImageUrl(e, i)
                                                }
                                                className="custom-formcontrol not_Allowed_Click"
                                              />
                                            </InputGroup>
                                          </div>
                                        </Form.Group>
                                        <img
                                          className="close-btn"
                                          src={closeIcon}
                                          onClick={(e) =>
                                            handleDeleteImage(e, i)
                                          }
                                        />
                                      </div>
                                    </div>
                                  ) : (
                                    <div
                                      className="upload-container"
                                      onMouseEnter={() => setIsHovered(true)}
                                      onMouseLeave={() => setIsHovered(false)}
                                    >
                                      <input
                                        className="input-file"
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) =>
                                          handleBannerImage(e, i)
                                        }
                                        onClick={(e) => (e.target.value = null)}
                                        id="upload"
                                      />
                                      <div className="upload-box">
                                        {" "}
                                        <img
                                          src={uploadArrow}
                                          style={{ width: 20 }}
                                        />
                                        <p className="info_bannerImg">
                                          Upload Banner Image
                                        </p>
                                      </div>
                                      <label
                                        for="upload"
                                        className="browse_btn"
                                      >
                                        Browse
                                      </label>
                                      <button
                                        className="remove_btn "
                                        id="right"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleDeleteImage(e, i);
                                        }}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </Col>
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <div className="url-image-wrapper">
                        <Col
                          md="12"
                          className="image-container"
                          onClick={addBannerFun}
                        >
                          <div className="upload-box new_upload_box">
                            <img src={uploadArrow} style={{ width: 20 }} />
                            <p className="info_bannerImg">
                              Click here to upload banner images
                            </p>
                          </div>
                        </Col>
                      </div>
                    )}
                    <Modal
                      show={showBanner}
                      onHide={() => setShowBanner(false)}
                      style={{ marginTop: 0 }}
                    >
                      <Modal.Header></Modal.Header>
                      <Modal.Body style={{ width: "100%", height: 350 }}>
                        <div>
                          <Cropper
                            image={profileimageBanner}
                            crop={crop}
                            rotation={rotation}
                            zoom={zoom}
                            aspect={3.33 / 1}
                            showGrid={true}
                            onCropChange={setCrop}
                            onRotationChange={setRotation}
                            onCropComplete={onCropComplete}
                            onZoomChange={setZoom}
                          />
                        </div>
                      </Modal.Body>
                      <Modal.Footer className="modelFooter">
                        <button
                          className="close_btn_cropper"
                          onClick={() => setShowBanner(false)}
                        >
                          Cancel
                        </button>
                        <button
                          className="green-btn mt-0 btn btn-primary"
                          onClick={showCroppedImageBanner}
                        >
                          Save
                        </button>
                      </Modal.Footer>
                    </Modal>
                  </Form.Group>
                  {BannerImgErr && (
                    <p className="text-danger">{BannerImgErr}</p>
                  )}
                </Col>
              </div>
              <Col md="6" className="">
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Page Name <span className="star-required"></span>
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      autoComplete="off"
                      type="text"
                      placeholder="Enter Page Name"
                      className="custom-formcontrol not_Allowed_Click"
                      value={PageName}
                      style={{
                        background: "#c4c4c4",
                        cursor: "not-allowed",
                        userSelect: "none",
                      }}
                      readOnly
                    />
                  </InputGroup>
                  {PageNameErr && <p className="text-danger">{PageNameErr}</p>}
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Page URL <span className="star-required"></span>
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      autoComplete="off"
                      type="text"
                      placeholder="Enter Page URL"
                      className="custom-formcontrol not_Allowed_Click"
                      value={PageUrl}
                      style={{
                        background: "#c4c4c4",
                        cursor: "not-allowed",
                        userSelect: "none",
                      }}
                      readOnly
                    />
                  </InputGroup>
                  {PageUrlErr && <p className="text-danger">{PageUrlErr}</p>}
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    <div>
                      Page Title <span className="star-required">*</span>
                      <p className="info-text-space">
                        &#40;"Appears in the browser tab",Maximum characters
                        allowed: 60&#41;
                      </p>
                    </div>
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      autoComplete="off"
                      type="text"
                      placeholder="Enter Page Title"
                      className="custom-formcontrol"
                      value={PageTitle}
                      maxLength={60}
                      onChange={(e) => {
                        onChangeHandler("PageTitle", e.target.value);
                      }}
                    />
                  </InputGroup>
                  {PageTitleErr && (
                    <p className="text-danger">{PageTitleErr}</p>
                  )}
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    <div>
                      Meta description <span className="star-required">*</span>
                      <p className="info-text-space">
                        &#40;Maximum characters allowed: 160&#41;
                      </p>
                    </div>
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      autoComplete="off"
                      type="text"
                      placeholder="Enter Meta Description"
                      className="custom-formcontrol"
                      value={MetaDescription}
                      maxLength={160}
                      onChange={(e) => {
                        onChangeHandler("MetaDescription", e.target.value);
                      }}
                    />
                  </InputGroup>
                  {MetaDescriptionErr && (
                    <p className="text-danger">{MetaDescriptionErr}</p>
                  )}
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Add Navigations <span className="star-required"> </span>
                    {["top"].map((placement) => (
                      <OverlayTrigger
                        key={placement}
                        placement={placement}
                        overlay={
                          <Tooltip
                            id={`tooltip-${placement}`}
                            className="Tooltips"
                            style={{ opacity: "1" }}
                          >
                            This is the main navigation on the home page. By
                            default, first one is the home page. You can choose
                            up to 4 more pages.
                          </Tooltip>
                        }
                      >
                        <Image
                          src={iicon}
                          className="mb-1"
                          width="15px"
                        ></Image>
                      </OverlayTrigger>
                    ))}
                  </Form.Label>
                  <p className="info-text">
                    &#40;To change the order of navigation, you can drag &
                    reorder, the drag function is toward the right of navigation
                    icon&#41;
                  </p>
                  {HideAddNav ? (
                    ""
                  ) : (
                    <InputGroup className="edit-border">
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder="Add Navigations"
                        className="custom-formcontrol"
                        onClick={handleAddNav}
                        value={AddNavigation}
                        onChange={(e) => {
                          onChangeHandler("AddNavigation", e.target.value);
                        }}
                      />
                    </InputGroup>
                  )}
                  {AddNavigationErr && (
                    <p className="text-danger">{AddNavigationErr}</p>
                  )}
                  {AddNavCheckBox ? (
                    <>
                      {" "}
                      <InputGroup className="edit-border mrk-check">
                        <Form.Group
                          className="mb-3 ack term-sec"
                          controlId="formBasicCheckbox"
                        >
                          <p className="max-text">(Max 4 navigations)</p>
                          {AddNavData.map((item, key) => {
                            return (
                              <>
                                <div className="orange-checkbox">
                                  <label
                                    for={item.navigation_id}
                                    value={item.navigation_id}
                                    className="checkbox-label bulk-notify-label"
                                  >
                                    <input
                                      type="checkbox"
                                      id={item.navigation_id}
                                      className="form-check-input bulk-notify-list"
                                      onChange={(e) => handleClick(e, key)}
                                      checked={isCheck.includes(
                                        item.navigation_name
                                      )}
                                      style={{ marginRight: 8 }}
                                      disabled={isDisable ? true : false}
                                    />
                                    {item.navigation_name}
                                  </label>
                                </div>
                              </>
                            );
                          })}
                          <div className="text-right">
                            <Button
                              className="check-green-btn2"
                              onClick={handleApplyCheckBox}
                            >
                              Apply
                            </Button>
                          </div>
                        </Form.Group>
                      </InputGroup>
                    </>
                  ) : (
                    ""
                  )}
                  {AddNavItems ? (
                    <>
                      <div id="varHeight">
                        <InputGroup className="edit-border mrk-check mrk-check-select mt-1">
                          <Form.Group
                            className="mb-3 ack term-sec"
                            controlId="formBasicCheckbox"
                          >
                            {AddNavData.length != 0 ? (
                              <DragDropContext onDragEnd={handleDropDataField}>
                                <Droppable droppableId="list-container">
                                  {(provided) => (
                                    <div
                                      {...provided.droppableProps}
                                      ref={provided.innerRef}
                                    >
                                      {isCheck.map((item, index) => (
                                        <Draggable
                                          key={item}
                                          draggableId={item}
                                          index={index}
                                        >
                                          {(provided) => (
                                            <div
                                              ref={provided.innerRef}
                                              {...provided.dragHandleProps}
                                              {...provided.draggableProps}
                                            >
                                              <Button>
                                                {item}{" "}
                                                <MdClose
                                                  onClick={(e) =>
                                                    handleDelete(e, index)
                                                  }
                                                />
                                              </Button>
                                            </div>
                                          )}
                                        </Draggable>
                                      ))}
                                      {provided.placeholder}
                                    </div>
                                  )}
                                </Droppable>
                              </DragDropContext>
                            ) : (
                              <p>
                                Please create new{" "}
                                <a href="/marketplace-setup/pages">
                                  <u>Page</u>
                                </a>{" "}
                                to add navigations
                              </p>
                            )}
                            {AddNavData.length != 0 ? (
                              <div className="text-right">
                                <Button
                                  className="check-green-btn2"
                                  onClick={handleEdit}
                                >
                                  <Image
                                    src={editwhite}
                                    className="mb-2"
                                  ></Image>{" "}
                                  {isCheck.length == 0 ? "Add" : "Edit"}
                                </Button>
                              </div>
                            ) : (
                              ""
                            )}
                          </Form.Group>
                        </InputGroup>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Add shortcuts <span className="star-required"></span>
                    {["bottom"].map((placement) => (
                      <OverlayTrigger
                        key={placement}
                        placement={placement}
                        overlay={
                          <Tooltip
                            id={`tooltip-${placement}`}
                            className="Tooltips"
                            style={{ opacity: "1" }}
                          >
                            This is the sub navigation on the home page. By
                            default, first one is "New Listing", second one is
                            "All Listings". You can choose up to 3 more
                            shortcuts.
                          </Tooltip>
                        }
                      >
                        <Image
                          src={iicon}
                          className="mb-1"
                          width="15px"
                        ></Image>
                      </OverlayTrigger>
                    ))}
                  </Form.Label>
                  <p className="info-text">
                    &#40;To change the order of shortcuts, you can drag &
                    reorder, the drag function is toward the right of navigation
                    icon&#41;
                  </p>
                  {HideAddShortcut ? (
                    ""
                  ) : (
                    <InputGroup className="edit-border">
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder="Add Shortcuts"
                        className="custom-formcontrol"
                        onClick={handleAddShortcut}
                        value={AddShortcuts}
                        onChange={(e) => {
                          onChangeHandler("AddShortcuts", e.target.value);
                        }}
                      />
                    </InputGroup>
                  )}
                  {AddShortcutsErr && (
                    <p className="text-danger">{AddShortcutsErr}</p>
                  )}
                  {AddShortcutCheckBox ? (
                    <>
                      <div>
                        <InputGroup className="edit-border mrk-check">
                          <Form.Group
                            className="mb-3 ack term-sec"
                            controlId="formBasicCheckbox"
                          >
                            <p className="max-text">(Max 3 shortcuts)</p>
                            {AddShortcutData.map((item, key) => {
                              return (
                                <>
                                  <div className="orange-checkbox">
                                    <label
                                      for={item.shortcut_id}
                                      value={item.shortcut_id}
                                      className="checkbox-label bulk-notify-label"
                                    >
                                      <input
                                        type="checkbox"
                                        id={item.shortcut_id}
                                        className="form-check-input bulk-notify-list"
                                        onChange={(e) =>
                                          handleClickShortcut(e, key)
                                        }
                                        checked={isCheckShortcut.includes(
                                          item.shortcut_name
                                        )}
                                        style={{ marginRight: 8 }}
                                        disabled={
                                          isDisableShortcut ? true : false
                                        }
                                      />
                                      {item.shortcut_name}
                                    </label>
                                  </div>
                                </>
                              );
                            })}
                            <div className="text-right">
                              <Button
                                className="check-green-btn2"
                                onClick={handleApplyCheckBoxShortcut}
                              >
                                Apply
                              </Button>
                            </div>
                          </Form.Group>
                        </InputGroup>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {AddShortcutItems ? (
                    <>
                      <InputGroup className="edit-border mrk-check mrk-check-select mt-1">
                        <Form.Group
                          className="mb-3 ack term-sec"
                          controlId="formBasicCheckbox"
                        >
                          {AddShortcutData.length != 0 ? (
                            <DragDropContext
                              onDragEnd={handleDropDataFieldShortcut}
                            >
                              <Droppable droppableId="list-container">
                                {(provided) => (
                                  <div
                                    className="list-container"
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                  >
                                    {isCheckShortcut.map((item, index) => (
                                      <Draggable
                                        key={item}
                                        draggableId={item}
                                        index={index}
                                      >
                                        {(provided) => (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.dragHandleProps}
                                            {...provided.draggableProps}
                                          >
                                            <Button>
                                              {item}{" "}
                                              <MdClose
                                                onClick={(e) =>
                                                  handleDeleteShortcut(e, index)
                                                }
                                              />
                                            </Button>
                                            <br />
                                          </div>
                                        )}
                                      </Draggable>
                                    ))}
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Droppable>
                            </DragDropContext>
                          ) : (
                            <p>
                              Please create new{" "}
                              <a href="/marketplace-setup/categories">
                                <u>Shortcut categories</u>
                              </a>{" "}
                              to add shortcut categories
                            </p>
                          )}
                          {AddShortcutData.length != 0 ? (
                            <div className="text-right">
                              <Button
                                className="check-green-btn2"
                                onClick={handleEditShortcut}
                              >
                                <Image src={editwhite} className="mb-2"></Image>{" "}
                                {isCheckShortcut.length == 0 ? "Add" : "Edit"}
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                        </Form.Group>
                      </InputGroup>
                    </>
                  ) : (
                    ""
                  )}
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Contact Email Address{" "}
                    <span className="star-required">*</span>
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      autoComplete="off"
                      type="text"
                      placeholder="Contact Email Address"
                      className="custom-formcontrol"
                      value={Email}
                      maxLength={70}
                      onChange={(e) => {
                        onChangeHandler("Email", e.target.value);
                      }}
                    />
                  </InputGroup>
                  {EmailErr && <p className="text-danger">{EmailErr}</p>}
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Contact Phone Number{" "}
                    <span className="star-required">*</span>
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      autoComplete="off"
                      type="text"
                      placeholder="Enter Phone Number"
                      className="custom-formcontrol"
                      value={Phone}
                      onChange={(e) => {
                        onChangeHandler("Phone", e.target.value);
                      }}
                      maxLength={15}
                    />
                  </InputGroup>
                  {PhoneErr && <p className="text-danger">{PhoneErr}</p>}
                </Form.Group>
              </Col>
              <hr className="hrSocial" />
              <p className="page-maintitle pt-1 pb-3">Social URL's</p>
              <Col md="6" className="">
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Facebook URL
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      autoComplete="off"
                      type="text"
                      placeholder="Enter Facebook URL Here"
                      className="custom-formcontrol"
                      value={Facebook}
                      onChange={(e) => {
                        onChangeHandler("Facebook", e.target.value);
                      }}
                    />
                  </InputGroup>
                  {FacebookErr && <p className="text-danger">{FacebookErr}</p>}
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">X URL</Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      autoComplete="off"
                      type="text"
                      placeholder="Enter X URL Here"
                      className="custom-formcontrol"
                      value={Twitter}
                      onChange={(e) => {
                        onChangeHandler("Twitter", e.target.value);
                      }}
                    />
                  </InputGroup>
                  {TwitterErr && <p className="text-danger">{TwitterErr}</p>}
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Instagram URL
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      autoComplete="off"
                      type="text"
                      placeholder="Enter Instagram URL Here"
                      className="custom-formcontrol"
                      value={Instagram}
                      onChange={(e) => {
                        onChangeHandler("Instagram", e.target.value);
                      }}
                    />
                  </InputGroup>
                  {InstagramErr && (
                    <p className="text-danger">{InstagramErr}</p>
                  )}
                </Form.Group>
              </Col>
              <Col md="6" className="">
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    LinkedIn URL
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Control
                      autoComplete="off"
                      type="text"
                      placeholder="Enter linkedIn URL Here"
                      className="custom-formcontrol"
                      value={LinkedIn}
                      onChange={(e) => {
                        onChangeHandler("LinkedIn", e.target.value);
                      }}
                    />
                  </InputGroup>
                  {LinkedInErr && <p className="text-danger">{LinkedInErr}</p>}
                </Form.Group>
              </Col>
            </Row>
            <div className="text-center small-btns d-flex option_btn">
              <Button className="discard_btn" onClick={handleDiscard}>
                Discard
              </Button>
              <Button
                variant="primary"
                type="submit"
                className="green-btn mt-3"
                onClick={(e) => handleSubmit(e)}
              >
                Save
              </Button>
            </div>
          </div>
        </Col>
        <Col md="1"></Col>
      </Row>
      <Modal
        className="center-div h-100"
        show={showCustomDomain}
        onHide={() => setShowCustomDomain(false)}
      >
        <Modal.Body style={{ width: "100%" }}>
          <div className="center-div gap-2">
            <img src={confirmationImage} alt="" height={80} width={80} />
            <p>Are you sure you want to apply for a custom domain?</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="modelFooter">
          <button
            className="close_btn_cropper"
            onClick={() => setShowCustomDomain(false)}
          >
            No
          </button>
          <button
            className="green-btn mt-0 btn btn-primary"
            onClick={requestHandlerApi}
            disabled={buttonDisabled}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
